import { CONTENT_TYPES } from '../constants/contentTypes';

// Every approval notification just lands on that content type's section page —
// no deep link to the specific record, no status tab to pre-select.
export const APPROVAL_NAVIGATION_ROUTES = {
  [CONTENT_TYPES.BOOTH]:           '/booth',
  [CONTENT_TYPES.BOOTH_MEDIA]:     '/booth',
  [CONTENT_TYPES.MEDIA]:           '/booth',
  [CONTENT_TYPES.PORTAL]:          '/booth',
  [CONTENT_TYPES.AD]:              '/advertisers',
  [CONTENT_TYPES.CAMPAIGN]:        '/advertisers',
  [CONTENT_TYPES.ADVERTISER]:      '/advertisers',
  [CONTENT_TYPES.ITEM]:            '/items',
  [CONTENT_TYPES.DISCOUNT]:        '/items',
  [CONTENT_TYPES.CHARITY]:         '/charities',
  [CONTENT_TYPES.HOSTING]:         '/hosting',
  [CONTENT_TYPES.RECOGNITION]:     '/recognition',
  [CONTENT_TYPES.REWARD]:          '/rewards',
  [CONTENT_TYPES.TELEPORT]:        '/teleport-map',
  [CONTENT_TYPES.TELEPORT_BUTTON]: '/teleport-map',
  [CONTENT_TYPES.LIGHTING]:        '/lighting',
  [CONTENT_TYPES.SELFIE]:          '/selfies',
  [CONTENT_TYPES.AI_MODERATION]:   '/ai-moderation',
  [CONTENT_TYPES.PAYMENT]:         '/payments',
  [CONTENT_TYPES.SUBSCRIPTION]:    '/subscriptions',
  [CONTENT_TYPES.GAME_SCHEDULE]:   '/game-schedule',
};

/**
 * Resolves where an approval notification click should navigate to, given the
 * approval's contentType. Discount shares the /items page with Item, so it needs
 * a bit of state to land on the discounts side instead of the default items side.
 */
export function resolveApprovalTarget(contentType) {
  if (contentType === CONTENT_TYPES.DISCOUNT) {
    return { pathname: '/items', state: { subTab: 'discounts' } };
  }

  const pathname = APPROVAL_NAVIGATION_ROUTES[contentType];
  return pathname ? { pathname } : { pathname: '/approvals' };
}
